<template>
<div class="page">

  <div class="menu">
    <el-menu
      :default-active="showModel"
      class="el-menu-vertical-demo"
      @select="select"
    >
      <el-menu-item index="1">
        <i class="el-icon-menu"></i>
        <span >model</span>
      </el-menu-item>
      <el-menu-item index="2">
        <i class="el-icon-document"></i>
        <span >model实例</span>
      </el-menu-item>
      <el-menu-item index="3">
        <i class="el-icon-setting"></i>
        <span>model任务</span>
      </el-menu-item>
    </el-menu>
  </div>
  <Model v-if="showModel==1" class="table"></Model>
  <ModelInstance  v-if="showModel==2" class="table"></ModelInstance>
  <ModelTask  v-if="showModel==3" class="table"></ModelTask>
</div>

</template>
<script>
 import { ref} from 'vue';
 import  store from 'store';
 import  Model from './model/index.vue';
 import  ModelTask from './modelTask/index.vue';
 import  ModelInstance from './modelInstance/index.vue';

export default {
  name:'modelMenu',
  components:{Model,ModelInstance,ModelTask},
  setup() {
    const showModel =ref();
    showModel.value=store.get('showModel')||1
    const select=(key, keyPath)=>{
        showModel.value=key
        store.set('showModel',key)
    }
    return{
      select,
      showModel,
    }
  },
}
</script>

<style scoped>
.page{
  width: 100%;
  display: flex;
}
.table{
  flex-grow: 1;
  min-width: 200px;
  padding: 10px;
}
.menu{
  width: 200px;
}
</style>